//#region IMPORTS
import { ReactNode } from "react";
import { motion } from "framer-motion";
//#endregion

//#region INTERFACE
interface Props {
  children?: ReactNode;
}
//#endregion

export default function LoadingOverlay({ children }: Props) {
  //#region SETUP
  const variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 0.6,
    },
  };
  //#endregion

  //#region RENDER
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="visible"
      className="fixed bg-white left-0 h-screen w-screen z-20"
    >
      {children}
    </motion.div>
  );
  //#endregion
}
